import React from "react";
import { LanguageCode } from "../../utils/translations";
import { HOME_COPY } from "./homeContent";
import SectionHeading from "./SectionHeading";
import ScrollRow from "./ScrollRow";
import { HOME_THEME, sectionPadding } from "./theme";

interface AutomationPlatformProps {
  lang: LanguageCode;
}

const AutomationPlatform: React.FC<AutomationPlatformProps> = ({ lang }) => {
  const { eyebrow, title, subtitle, stages } = HOME_COPY[lang].howItWorks;

  return (
    <section style={{ padding: sectionPadding, background: HOME_THEME.dark }}>
      <ScrollRow
        ariaLabel="How it works steps"
        header={
          <SectionHeading
            align="center"
            noMargin
            onDark
            eyebrow={eyebrow}
            title={title}
            subtitle={subtitle}
          />
        }
      >
        {stages.map((s) => (
          <div
            key={s.key}
            style={{
              flex: "0 0 auto",
              width: "280px",
              scrollSnapAlign: "start",
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "14px",
              padding: "18px",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "40px",
                height: "40px",
                borderRadius: "12px",
                background: "rgba(1,126,132,0.18)",
                color: HOME_THEME.primary,
                fontWeight: 900,
                fontSize: "0.85rem",
                marginBottom: "14px",
              }}
            >
              {s.step}
            </span>
            <h3 style={{ margin: "0 0 6px 0", fontSize: "1rem", color: "#fff" }}>
              {s.title}
            </h3>
            <p
              style={{
                margin: 0,
                fontSize: "0.9rem",
                lineHeight: 1.55,
                color: HOME_THEME.onDarkMuted,
              }}
            >
              {s.desc}
            </p>
          </div>
        ))}
      </ScrollRow>
    </section>
  );
};

export default AutomationPlatform;
